import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_END = {
  title: "Find out more about ‘AI Twin for Marketers’ from our staff",
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage(301),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage(305),
      startIcon: "arrow-right",
    },
  ],
};
